import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    DialogActions,
    Button,
    useTheme,
    Box,
    Typography
} from '@mui/material';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

const ContactPopup = ({ open, onClose }) => {
    const theme = useTheme();
    const { user } = useAuth();

    // Build email body with user info if logged in
    const getEmailBody = () => {
        if (!user) return '';
        const body = `\n\n---\nAccount Info:\nName: ${user.firstName} ${user.lastName}\nUsername: ${user.ssUsername}\nClient ID: ${user.ezFacilityClientId || 'N/A'}\n---`;
        return `&body=${encodeURIComponent(body)}`;
    };

    const contactOptions = [
        {
            icon: <EmailIcon />,
            label: 'Email TTE',
            action: () => window.location.href = `mailto:info@totalturf.net?subject=${encodeURIComponent(`Admin Portal Issues${user?.ssUsername ? ` (${user.ssUsername})` : ''}`)}${getEmailBody()}`,
            description: 'Send us an email at info@totalturf.net'
        },
        {
            icon: <PhoneIcon />,
            label: 'Call TTE',
            action: () => window.location.href = 'tel:+18562188091',
            description: 'Call us at (856) 218-8091'
        }
    ];

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    '& .MuiDialogTitle-root': {
                        backgroundColor: theme.palette.primary.main,
                        color: 'white',
                        py: 2
                    }
                }
            }}
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" component="span">
                        Contact Total Turf Experience
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <DialogContentText sx={{ mb: 3, color: 'text.primary' }}>
                    Please select how you would like to contact us:
                </DialogContentText>
                <List sx={{ 
                    mt: 1,
                    '& .MuiListItem-root:not(:last-child)': {
                        mb: 1
                    }
                }}>
                    {contactOptions.map((option, index) => (
                        <ListItem key={index} disablePadding>
                            <ListItemButton 
                                onClick={() => {
                                    option.action();
                                    onClose();
                                }}
                                sx={{
                                    border: '1px solid',
                                    borderColor: theme.palette.primary.light,
                                    borderRadius: 1,
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.light + '1A',
                                        borderColor: theme.palette.primary.main,
                                        transform: 'translateY(-1px)'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Box sx={{ mr: 2, color: theme.palette.primary.main }}>
                                        {option.icon}
                                    </Box>
                                    <ListItemText 
                                        primary={option.label}
                                        secondary={option.description}
                                        primaryTypographyProps={{
                                            sx: { 
                                                fontWeight: 500,
                                                color: 'text.primary'
                                            }
                                        }}
                                    />
                                </Box>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    color="primary"
                    sx={{
                        borderRadius: 1,
                        textTransform: 'none',
                        px: 3
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactPopup; 